import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { Gift } from 'lucide-react';
import { useMissions } from '@/hooks/useMissions';

export default function ChallengeProgress() {
  const { missions } = useMissions();

  const isExpired = (challenge: any) =>
    challenge?.end_date && new Date(challenge.end_date) < new Date();

  const activeMissions =
    missions?.filter((mission) => !isExpired(mission)) || [];

  // Calculate dynamic separator width to fit all challenges within max-w-2xl (672px)
  // Formula: maxWidth - (gifts + gaps) / numberOfSeparators
  const separatorWidth =
    activeMissions.length > 1
      ? Math.max(
          4,
          Math.floor(
            (672 -
              activeMissions.length * 40 -
              (activeMissions.length - 1) * 16) /
              (activeMissions.length - 1)
          )
        )
      : 0;

  return (
    <div className="max-w-2xl mx-auto">
      <div className="flex flex-row items-center justify-center flex-wrap gap-x-2 gap-y-4">
        {activeMissions?.length > 0 ? (
          <>
            {activeMissions.map((mission, index) => (
              <div
                className="flex flex-row items-center gap-2"
                key={mission.id}
              >
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Gift
                      className={
                        mission.partnerMissionStatus === 'completed'
                          ? 'text-heineken-light-green'
                          : 'text-heineken-grey'
                      }
                      size={40}
                    />
                  </TooltipTrigger>
                  <TooltipContent
                    sideOffset={16}
                    className={
                      mission.partnerMissionStatus === 'completed'
                        ? 'bg-white border-1 border-heineken-light-green text-lg'
                        : 'bg-white border-1 border-[#808080] text-lg'
                    }
                    side="bottom"
                  >
                    <p
                      className={
                        mission.partnerMissionStatus === 'completed'
                          ? 'text-heineken-light-green'
                          : 'text-[#4a4a4a]'
                      }
                    >
                      {mission.name}
                    </p>
                    <p
                      className={
                        mission.partnerMissionStatus === 'completed'
                          ? 'text-heineken-light-green'
                          : 'text-[#4a4a4a]'
                      }
                    >
                      {mission.partnerMissionStatus === 'completed'
                        ? 'Megszerezve: '
                        : ''}
                      +{mission.rewardRules?.amount ?? 0} kredit
                    </p>
                  </TooltipContent>
                </Tooltip>
                {index < activeMissions.length - 1 && (
                  <div
                    className="h-[2px] bg-[#DCDFE4]"
                    style={{ width: separatorWidth }}
                  ></div>
                )}
              </div>
            ))}
          </>
        ) : (
          <p className="text-lg text-center">
            Jelenleg nincs elérhető küldetés
          </p>
        )}
      </div>
    </div>
  );
}
